import React from "react";
import { Row } from "react-bootstrap";

function FiltHeaderText({
  text,
  page = "",
  subtype = false,
  isRequired = true,
}) {
  var className = " ";
  if (page === "corp-action") {
    className = " pl-3 pb-2 ";
  } else if (subtype === true) {
    className = " pl-3 ";
  } else if (page === "adjustment") {
    className = "headerText";
  }

  return (
    <>
      <Row>
        <div className="starstyle">
          {page !== "corp-action" &&
          page !== "trade-order-file-instruction" &&
          isRequired &&
          !subtype
            ? "*"
            : ""}
        </div>
        {/* {
          (page = "trade-order-file-instruction" && !subtype && (
            <div className="pl-3"></div>
          ))
        } */}
        <div
          className={`${"textfilterhead" + className}`}
          style={{
            paddingBottom: subtype ? "5px" : null,
          }}
        >
          {text + (!isRequired ? " (Optional)" : "")}
        </div>
      </Row>
    </>
  );
}

export default FiltHeaderText;
